import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 23 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#f25022",
      d: "M1 1h10v10H1z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#7fba00",
      d: "M12 1h10v10H12z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#00a4ef",
      d: "M1 12h10v10H1z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#ffb900",
      d: "M12 12h10v10H12z"
    }, null, -1)
  ])))
}
export default { render: render }